import EventEmitter from 'eventemitter3'
let EE = new EventEmitter()
export default EE
